<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center" style="padding: 100px 0px">
          <!-- /.box-header -->
          <div class="col-xs-4" style="padding: 0px 5px 0px 10px">
            <router-link :to="'/crActivityInfoForm?rule_code=SA00001'">
              <button class="btn btn-success btn-activity">
                <span class="text-w-600">贈送優惠券</span><br>
                <small>消費金額滿額</small>
              </button>
            </router-link>
          </div>
          <div class="col-xs-4" style="padding: 0px 10px 0px 5px">
            <router-link :to="'/crActivityInfoForm?rule_code=SA00002'">
              <button class="btn btn-primary btn-activity">
                <span class="text-w-600">贈送優惠券</span><br>
                <small>消費商品數量滿額</small>
              </button>
            </router-link>
          </div>
          <div class="col-xs-4" style="padding: 0px 10px 0px 5px">
            <router-link :to="'/crActivityInfoForm?rule_code=SA00003'">
              <button class="btn btn-warning btn-activity">
                <span class="text-w-600">贈送優惠券</span><br>
                <small>消費指定商品滿額</small>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import activityBuyForm from './Temp/ActivityBuyForm.vue'
import activityRegisterForm from './Temp/ActivityRegisterForm.vue'
export default {
  components: {
    'activity-buy-form': activityBuyForm,
    'activity-register-form': activityRegisterForm
  },
  data () {
    return {
      activityMethod: 1
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>

<style lang="sass" scoped>
  .btn-activity
    width: 100%
    max-width: 400px
    padding: 20% 0px
    font-size: 200%
    small
      font-size: 60%
  @media screen and (max-width: 991px)
    .btn-activity
      font-size: 13px
</style>



// WEBPACK FOOTER //
// CrActivity.vue?6ec49077